<template>
    <div class="page-list">
        <a :href="'./news_details.html?active='+active+'&id='+item.id" v-for="(item,index) in dataList" :key="index" class="page-list-li">
            <div class="notice_item_time">
                <div class="notice_item_time_year">
                    {{item.modifyTime | datefilterYear}}
                </div>
                <div class="notice_item_time_month">
                    {{item.modifyTime | datefilterDay}}
                </div>
            </div>
            <div class="notice_item_txt">
                <div>
                    {{item.contentTitle}}
                </div>
            </div>
        </a>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="from.pageNo"
            :page-sizes="[10, 20, 50,100]" :page-size="from.pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total" style="text-align: right;padding: 40px 0 40px 0;" v-show="dataList.length!='0'">
        </el-pagination>
    </div>
</template>
<script>
/**
 * Component newsCardList 页脚组件
 	@author fanjun
  @props data（必选属性前面带＊，非必选项目请备注默认值）
    －*type : String,'1'(默认) - 1、政策法规 2、行业新闻  3、通知公告
    active : String,'2'(默认) - 2、政策法规 3、行业新闻  4、通知公告
	@example
	<footer/>
**/
import { Pagination } from "element-ui";
import "./index.scss";
export default {
    name: "newsCardList",
    components: {
        [Pagination.name]: Pagination,
    },
    props: {
        type: {
            type: String,
            required: true,
            default: "1",
        },
        active: {
            type: String,
            required: false,
            default: "2",
        },
    },
    data() {
        return {
            from: {
                postType: "",
                pageNo: 1,
                pageSize: 10,
            },
            dataList: [],
            total: 50,
            checkForm: {
                status: "2", //已发布
                contentCategoryId: "", //152-政策法规、153-行业新闻、154-通知公告
                companId: 0,
                indexFlag: "Y",
                pageNum: 1,
                pageSize: 10,
            },
        };
    },
    filters: {
        datefilter: function (val) {
            var date = new Date(val);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + m + "-" + d;
        },
        datefilterYear:function(val){
            var date = new Date(val);  
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            var d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            return y ;
        },
        datefilterDay:function(val){
            var date = new Date(val);  
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            var d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            return m + '-' + d ;
        }
    },
    created() {
        console.log(this.type);
        if (this.type == "1") {
            this.checkForm.contentCategoryId = "152";
        } else if (this.type == "2") {
            this.checkForm.contentCategoryId = "153";
        } else if (this.type == "3") {
            this.checkForm.contentCategoryId = "154";
        }
        this.getData(); //获取数据
    },
    methods: {
        getData: function () {
            this.$api
                .queryContentList(this.checkForm)
                .then((res) => {
                    console.log(res);
                    if (res.data.resultCode == 200) {
                        this.dataList = res.data.result;
                        this.total = res.data.total;
                    } else {
                        this.$message.error({ title: res.data.resultDesc });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handleCurrentChange: function (pageNum) {
            // 改变页码
            this.checkForm.pageNum = pageNum;
            this.getData();
        },
        handleSizeChange: function (val) {
            this.checkForm.pageSize = val;
            this.checkForm.pageNum = 1;
            this.getData();
        },
    },
};
</script>

